import { orderList } from '@/services/payment'
import { OrderItem, OrderListRes } from '@/services/types/payment'
import { useEffect, useRef, useState } from 'react'
import SJCard from '@/components/SJCard'
import icons from '@/assets/icons'
import SJNoData from '@/components/SJNoData'
import { InfiniteScroll, PullToRefresh } from 'antd-mobile'
import './index.less'
import { useNavigate } from 'react-router-dom'

const OrderList = () => {
  document.title = '我的订单'
  const navigate = useNavigate()
  const pageRef = useRef(1)
  const sizeRef = useRef(10)
  const [hasMore, setHasMore] = useState(true)
  const [orders, setOrders] = useState<OrderItem[]>([])
  const fetchOrderList = async (page = 1, size = sizeRef.current) => {
    try {
      const res = (await orderList({ page, size })) as unknown as OrderListRes
      if (page === 1) {
        setOrders(res.list)
      } else {
        setOrders(orders.concat(res.list))
      }
      pageRef.current = res.page
      setHasMore(res.pageTotal > res.page)
    } catch (error) {}
  }

  useEffect(() => {
    fetchOrderList()
  }, [])
  const fetchMore = async () => {
    hasMore && (await fetchOrderList(pageRef.current + 1))
  }

  const goOrderDetail = (orderType: number, orderCode: string) => {
    if (orderType === 1) {
      navigate(`/order/detail?orderCode=${orderCode}`)
    } else if (orderType === 2) {
      navigate(`/order/detail2?orderCode=${orderCode}`)
    }
  }

  const GradeIcon = (code: string) => {
    if (code === '100016' || code === '101276') {
      return icons[`IconGrade16`]
    } else if (code === '100015' || code === '101457') {
      return icons[`IconGrade15`]
    } else if (code === '100014' || code === '101388') {
      return icons[`IconGrade14`]
    } else if (code === '101210') {
      return icons[`IconGrade13`]
    } else {
      return ''
    }
  }

  const Status = ['待付款', '已支付', '退款中', '已关闭', '已关闭', '已关闭', '已关闭']

  return (
    <div className="page order-list">
      <PullToRefresh onRefresh={fetchOrderList}>
        <div className="main">
          {orders?.map((item) => (
            <SJCard
              className="order"
              key={item.orderCode}
              onClick={() => goOrderDetail(item.productType, item.orderCode)}
            >
              <div className="order-header">
                <span className="order-title">
                  {item.productType === 1 ? '评测报名' : '课程购买'}
                </span>
                <span className={`order-status order-status-${item.status}`}>
                  {Status[item.status]}
                </span>
              </div>
              <div className="order-body">
                <img className="grade" src={GradeIcon(item.productCode)} alt="" />
                <div className="flex-1">
                  <div className="order-desc">{item.productName}</div>
                </div>
              </div>
              {item.status === 0 && (
                <div className="order-footer">
                  <div className="btn btn-cancel">取消订单</div>
                  <div className="btn btn-pay">继续支付</div>
                </div>
              )}
            </SJCard>
          ))}
          {orders.length ? (
            <InfiniteScroll loadMore={fetchMore} hasMore={hasMore}></InfiniteScroll>
          ) : (
            <SJNoData />
          )}
        </div>
      </PullToRefresh>
    </div>
  )
}

export default OrderList
